import { render, staticRenderFns } from "./TerminatedEmployees.vue?vue&type=template&id=255e4185&"
import script from "./TerminatedEmployees.vue?vue&type=script&lang=js&"
export * from "./TerminatedEmployees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports